var ALTERNATE_ROSTER_TEXTS = {
    title: {
        Clever: 'Clever',
        ClassLink: 'ClassLink',
    },
    paragraph: {
        Clever: 'Your students are set up. They will now see the Dino icon in their Clever accounts.',
        ClassLink: 'Your students are set up. They will now see the Happy Numbers app in their ClassLink accounts.',
    },
    help: {
        Clever: 'Please contact your school Clever admin or refer to the Clever Help Center. Once your class info is changed in the Clever portal it will automatically be synced with your Happy Numbers account.',
        ClassLink: 'Please contact your school ClassLink admin. Once your class info is changed in the ClassLink portal, inform us about changes so we can sync them with your Happy Numbers account.',
    },
    link: {
        Clever: 'https://www.clever.com/',
        ClassLink: 'https://www.launchpad.classlink.com/',
    },
    linkText: {
        Clever: 'clever.com',
        ClassLink: 'launchpad.classlink.com',
    },
};
export { ALTERNATE_ROSTER_TEXTS };
